import type { EndpointDef } from '@skynet/data-helpers';

/**
 * Central endpoint definitions — single source of truth for the Items API.
 *
 * This file drives:
 * - **Enhanced API**: computed endpoint keys in `enhanceEndpoints`
 * - **Hook re-exports**: clean name → generated name mapping
 * - **MSW mock factories**: HTTP method + URL path pattern
 *
 * When the OpenAPI spec changes and codegen regenerates, update this
 * file to keep everything in sync.
 */

/**
 * Endpoint definitions keyed by clean export name.
 *
 * Each entry maps a human-friendly name to:
 * - `generated` — the codegen-produced RTK Query endpoint name, derived from the OpenAPI operationId
 * - `method` — HTTP verb
 * - `path` — URL pattern (MSW-compatible `:param` syntax)
 */
export const ITEMS_API_ENDPOINTS = {
  createItem: {
    generated: 'itemsControllerCreateV1',
    method: 'post',
    path: '/api/v1/items',
  },
  listItems: {
    generated: 'itemsControllerIndexV1',
    method: 'get',
    path: '/api/v1/items',
  },
  getItem: {
    generated: 'itemsControllerShowV1',
    method: 'get',
    path: '/api/v1/items/:id',
  },

  updateItem: {
    generated: 'itemsControllerUpdateV1',
    method: 'put',
    path: '/api/v1/items/:id',
  },
  deleteItem: {
    generated: 'itemsControllerRemoveV1',
    method: 'delete',
    path: '/api/v1/items/:id',
  },
  publishItem: {
    generated: 'itemsControllerPublishV1',
    method: 'post',
    path: '/api/v1/items/:id/publish',
  },
  unpublishItem: {
    generated: 'itemsControllerUnpublishV1',
    method: 'post',
    path: '/api/v1/items/:id/unpublish',
  },
} as const satisfies Record<string, EndpointDef>;

export type ItemsEndpointName = keyof typeof ITEMS_API_ENDPOINTS;
